/*
===============================================================================================================
                                 Copyright 2022-2023, Blue Yonder Group, Inc.
                                              All Rights Reserved

                                THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
                                            BLUE YONDER GROUP, INC.

                            The copyright notice above does not evidence any actual
                                 or intended publication of such source code.

===============================================================================================================
*/

import getImageDimensionsFromFile from '@/utilities/getImageDimensions';

export const ALLOWED_IMAGE_FILE_TYPES = ['image/jpeg', 'image/png'];
export const MAX_IMAGE_SIZE = 2000000;

const imageWithinBounds = ({ width, height }, validationRules) => {
  if (validationRules.minWidth && width < validationRules.minWidth) {
    return { valid: false, error: validationRules.imageTooSmallError };
  }

  if (validationRules.maxWidth && width > validationRules.maxWidth) {
    return { valid: false, error: validationRules.imageTooLargeError };
  }

  if (validationRules.minHeight && height < validationRules.minHeight) {
    return { valid: false, error: validationRules.imageTooSmallError };
  }

  if (validationRules.maxHeight && height > validationRules.maxHeight) {
    return { valid: false, error: validationRules.imageTooLargeError };
  }

  return { valid: true, error: '' };
};

const validateFile = async (fileData, validationRules) => {
  if (!ALLOWED_IMAGE_FILE_TYPES.includes(fileData.type)) {
    return {
      valid: false,
      error: 'constants.invalidImageType',
    };
  }

  if (fileData.size > MAX_IMAGE_SIZE) {
    return {
      valid: false,
      error: 'constants.invalidFileMaxSize',
    };
  }
  // need to first check if validationRules is defined
  const validationRulesDefined = validationRules && Object.values(validationRules).some((value) => value !== undefined);

  // if some validation rules are defined, then we need to validate the image
  if (validationRulesDefined) {
    try {
      const { width, height } = await getImageDimensionsFromFile(fileData);
      const { valid, error } = imageWithinBounds({ width, height }, validationRules);
      if (!valid) {
        return {
          valid,
          error,
        };
      }
    } catch (error) {
      return {
        valid: false,
        error: 'constants.invalidFileType',
      };
    }
  }

  return {
    valid: true,
  };
};

export default validateFile;
